module.exports = __webpack_public_path__ + "static/img/14002014.4a382b97.png";